import css from './index.module.scss';
import { LineSpace } from '@/components/ProductComponents';
import { TextOnImage, TextWithImage } from '@/components/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import NextImage from '@/components/NextImage';
import OtherList from '@/components/ProductCommon/OtherList';

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_max'],
    cis: ['product_ps_delta_delta_2', 'product_ps_delta_delta_pro', 'product_ps_delta_delta_max'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_256', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    mx: ['product_ps_delta_delta_3_s', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
};

export default function Content() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const { t } = useLang('220wbifacialsolarpanel');
    const languageT = (value: string) => t(`solarpanels_220w.${value}`);
    const webpUrl = '/media/220W/pc/';

    const item1 = {
        synopsis: languageT('third_title'),
        desc: languageT('third_des'),
        bgImgs: '/img/productDetails/solarpanel_220w/1.png',
    };
    const textData1 = {
        img_url: ['mx'].includes(locale)
            ? 'https://websiteoss.ecoflow.com/upload/image/1746697047746/220w.png'
            : ['cis', 'sa'].includes(locale)
            ? [`2_${locale === 'cis' ? 'ru' : 'sa-ar'}.webp`, `2_${locale === 'cis' ? 'ru' : 'sa-ar'}.jpg`]
            : [`2_${imgLocal}.webp`, `2_${imgLocal}.jpg`],
        synopsis: languageT('four_title'),
        desc: languageT('four_des'),
        tip: languageT('four_tip'),
    };
    const textData2 = {
        title: '',
        synopsis: languageT('five_title'),
        desc: `${languageT('five_des')}
            <strong class="bb">${languageT('five_des_s')}</strong>
            ${languageT('five_des1')}
            <strong class="bb">${languageT('five_des_s1')}</strong>
           ${languageT('five_des2')}
            <strong class="bb hide">${languageT('five_des_s2')}</strong>${languageT('five_des3')}`,
        footerNote: languageT('five_tip'),
        bgImgs: '/img/productDetails/solarpanel_220w/3.png',
        noUseHtmlAttr: true,
        arr: [
            {
                num: languageT('five_item_num'),
                eum: languageT('five_item_eum'),
                desc: languageT('five_item_desc'),
            },
            {
                num: languageT('five_item_num1'),
                eum: '',
                desc: languageT('five_item_desc1'),
            },
        ],
    };
    const textData3 = {
        synopsis: languageT('six_title'),
        desc: languageT('six_des'),
        bgImgs: '/img/productDetails/solarpanel_220w/4.png',
    };
    const textData4 = {
        img_url: '/img/productDetails/solarpanel_220w/5.png',
        synopsis: languageT('seven_title'),
        desc: languageT('seven_des'),
    };
    const textData5 = {
        img_url: '/img/productDetails/solarpanel_220w/6.png',
        synopsis: languageT('eight_title'),
        desc: languageT('eight_des'),
        tip: languageT('eight_tip'),
    };
    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <LineSpace height={180} background="transparent" />
            <div className="banner-content">
                <div className="section section1">
                    <div className="section sec1-top">
                        <h3 className="tit">{languageT('second_bifacial')}</h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_220w/pc/Y-1.webp')}
                                src={require('@publicLocal/product/solarpanel_220w/pc/Y-1.png')}
                                className="fullImgs"
                                alt={languageT('second_bifacial')}
                            />
                        </div>
                    </div>
                    <div className="section sec1-btm">
                        <h3 className="tit">{languageT('second_hight_efficiency')}</h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_220w/pc/Y-4.webp')}
                                src={require('@publicLocal/product/solarpanel_220w/pc/Y-4.png')}
                                className="fullImgs"
                                alt={languageT('second_hight_efficiency')}
                            />
                        </div>
                    </div>
                </div>
                <div className="section section2">
                    <div className="section sec2-top">
                        <div className="section sec2-top-l">
                            <h3 className="tit">{languageT('second_kickstand_case')}</h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_220w/pc/Y-2.webp')}
                                    src={require('@publicLocal/product/solarpanel_220w/pc/Y-2.png')}
                                    className="fullImgs"
                                    alt={languageT('second_kickstand_case')}
                                />
                            </div>
                        </div>
                        <div className="section sec2-top-r">
                            <h3 className="tit">{languageT('second_wide_compatibility')}</h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_220w/pc/Y-3.webp')}
                                    src={require('@publicLocal/product/solarpanel_220w/pc/Y-3.png')}
                                    className="fullImgs"
                                    alt={languageT('second_wide_compatibility')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="section sec2-btm">
                        <h3 className="tit">
                            {languageT('second_waterproof')}
                            <span>{languageT('second_ip')}</span>
                        </h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_220w/pc/sec2-btm.webp')}
                                src={require('@publicLocal/product/solarpanel_220w/pc/sec2-btm.jpg')}
                                className="fullImgs"
                                alt={languageT('second_waterproof')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <LineSpace height={180} background="transparent" />
            <div className="textOnImg1">
                <TextOnImage data={item1} config={{ position: 'top', descFontSize: locale === 'jp' ? '20' : '22' }} />
            </div>
            <LineSpace height={280} background="transparent" />
            <div className="textWithImg1 t1">
                <TextWithImage
                    data={textData1}
                    config={{
                        position: 'top',
                        descFontSize: locale === 'jp' ? '20' : '22',
                        width: (() => {
                            const map = {
                                es: '964px',
                            };
                            return map[locale as keyof typeof map] || '924px';
                        })(),
                        webpUrl,
                    }}
                />
            </div>
            <LineSpace height={180} background="transparent" />
            <div className="container text2">
                <TextOnImage
                    data={textData2}
                    config={{
                        position: locale == 'sa' ? 'right' : 'left',
                        descFontSize: locale === 'jp' ? '20' : '22',
                    }}
                />
            </div>
            <LineSpace height={80} background="transparent" />
            <div className="container">
                <div className="textOnImg2">
                    <TextOnImage data={textData3} config={{ position: locale == 'sa' ? 'left' : 'right', descFontSize: locale === 'jp' ? '20' : '22' }} />
                </div>
            </div>
            <LineSpace height={180} background="transparent" />

            <div className="textWithImg1">
                <TextWithImage
                    data={textData4}
                    config={{
                        position: 'top',
                        descFontSize: ['jp', 'fr'].includes(locale) ? '20' : '22',
                    }}
                />
            </div>
            <LineSpace height={270} background="transparent" />

            <TextWithImage
                data={textData5}
                config={{
                    position: 'top',
                    synopsisFontSize: locale === 'jp' ? '61' : '64',
                    descFontSize: locale === 'jp' ? '20' : '22',
                }}
            />
            <LineSpace height={280} background="transparent" />
            <OtherList
                data={getDetaileMoreProducts(
                    gloproductlist,
                    product[locale] || product.us,
                    '',
                    '',
                    `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                )}
            />
        </div>
    );
}
